(ns app.front.view.admin.commands.workspace-delete
  (:require [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.admin.entity-table :as entable]
            [app.front.view.group.admin.common :as acommon]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::state
  :-> ::state)

(rf/reg-event-db ::set-workspace-id
  (rf/path [::state])
  (fn [state [_ new-workspace-id]]
    (-> state
        (assoc :workspace-id new-workspace-id)
        (dissoc :workspace-data :workspace-deleted))))

(rf/reg-sub ::workspace-id
  :<- [::state]
  (fn [state _] (:workspace-id state "")))

(rf/reg-sub ::workspace-id-valid?
  :<- [::workspace-id]
  (fn [workspace-id _]
    (nil? (workspace-model/check-workspace-id workspace-id))))

(rf/reg-event-fx ::get-workspace-for-deletion
  (fn [_ [_ workspace-id]]
    {:comm/command {:command    :admin/get-workspace-for-deletion
                    :method     :get
                    :data       (util/mmap workspace-id)
                    :on-success [::get-workspace-for-deletion.success]}}))

(rf/reg-event-fx ::get-workspace-for-deletion.success
  (fn [{:keys [db]} [_ _status resp]]
    {:db (-> db
             (assoc-in [::state :workspace-data] resp)
             (update ::state dissoc :workspace-deleted))}))

(rf/reg-event-fx ::delete-workspace
  (fn [_ [_ workspace-id]]
    {:comm/command {:command    :admin/delete-workspace
                    :data       (util/mmap workspace-id)
                    :on-success [::delete-workspace.success]}}))

(rf/reg-event-fx ::delete-workspace.success
  (fn [{:keys [db]} [_ status resp]]
    {:db       (-> db
                   (assoc-in [::state :workspace-deleted] true)
                   (update ::state dissoc :workspace-data))
     :dispatch [::entities/apply-changes status resp]}))

(rf/reg-sub ::workspace-data
  :<- [::state]
  :-> :workspace-data)

(rf/reg-sub ::workspace-deleted
  :<- [::state]
  :-> :workspace-deleted)

(defn help-text []
  [:section
   [:p "This tool allows you to " [:span.font-bold "delete"] " a workspace. "
    [:span.font-bold "Use with extreme caution!"]]
   [:p "It will delete a workspace and all its children. "
    [:span.font-bold "In practice the operation is irreversible!"]]])

(defn workspace-info []
  (when-some [workspace-data (<sub [::workspace-data])]
    (let [{{:workspace/keys [id municipal-case-id]} :workspace
           {:group/keys [name]}                     :authority-group
           txes                                     :workspace-delete-txes
           file-count                               :file-delete-count}    workspace-data
          title                                                            (str "Delete workspace " id)]
      [:<>
       [:div.flex.justify-start.flex-1
        (let [tr                  (<sub [:tr])
              trigger-button-text "Delete workspace"
              on-yes-click        #(>evt [::delete-workspace id])]
          [ui/modal-confirmation-button
           (util/mmap {:id "workspace-delete"} tr trigger-button-text on-yes-click)
           [:p.bold (str "Are you sure you want to delete workspace " id "?")]])]
       [:section.bx--row.audit-log__tx
        [:div.audit-log__tx-header.bx--col-xs-12.flex-col.justify-between.items-baseline
         [:div.flex-0.mb-4 title]
         [:div.flex-0.mb-1 "Municipal case id: " (or municipal-case-id "-")]
         [:div.flex-0.mb-1 "Group: " name]
         [:div.flex-0.mt-4 "Number of files to be deleted from storage: " file-count]]
        [:div.audit-log__tx-changes.bx--col-xs-12
         [entable/entity-table
          {:id     (str "workspace-delete-txes" id)
           :title  title
           :datoms (map (fn [tx-data]
                          {:attribute (first tx-data)
                           :value     (last tx-data)})
                        txes)
           :hidden #{}}]]]])))

(defn workspace-deleted [workspace-id]
  (when (<sub [::workspace-deleted])
    [:h5 (str "Workspace " workspace-id " deleted!")]))

(defn wizard []
  (let [workspace-id (<sub [::workspace-id])]
    [:section
     [:h2 "Delete workspace"]
     [:form.flex.items-end.mb-4
      {:on-submit (fn [ev]
                    (.preventDefault ev)
                    (>evt [::get-workspace-for-deletion workspace-id]))}
      [ui/text-input
       {:id         "delete-workspace-id"
        :label-text "ID of the workspace to be deleted"
        :on-change  #(rf/dispatch-sync [::set-workspace-id (futil/tval %)])
        :value      workspace-id}]
      [:div.ml-2
       (cc/button
         {:type     :submit
          :disabled (not (<sub [::workspace-id-valid?]))}
         "Find workspace")]]
     [workspace-info]
     [workspace-deleted workspace-id]]))

(defn view [match]
  [acommon/admin-page
   (util/mmap {:title "Delete workspace"} match)
   [help-text]
   [wizard]])

(def route
  {:name :view/admin.commands.workspace-delete
   :view view})
